/* XPlamps 2.0 — 预测搜索（归属 B / B2）。
   自定义元素 <xp-predictive-search>：监听 header 派发的 cancelable 'search:open'，打开 <dialog>；
   输入防抖后请求 Section Rendering API（routes.predictive_search_url + section_id），把 #XpPredictiveResults 片段换进来。
   快捷键：“/”（焦点不在输入框时）打开；Esc 关闭；↓/↑ 在输入框和结果链接之间移动。 */
(function () {
  if (customElements.get('xp-predictive-search')) return;

  var MQ_REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var CLOSE_MS = 320;
  var DEBOUNCE_MS = 220;
  var MIN_CHARS = 2;

  class XpPredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('#XpSearchResults');
      this.quick = this.querySelector('[data-search-quick]');
      this.clearBtn = this.querySelector('[data-search-clear]');
      this.status = this.querySelector('[data-search-status]');
      this.quickHTML = this.quick ? this.quick.outerHTML : '';
      this.cache = {};
      this.abort = null;
      this.timer = null;
      this.loadTimer = null;
      this.lastQuery = '';   // 当前面板里展示的是哪个词的结果（只有成功渲染后才写）
      this.pending = '';     // 正在请求中的词（失败要能重来，所以不写进 lastQuery）
      if (!this.dialog || !this.input) return;
      this.bind();
    }

    disconnectedCallback() {
      document.removeEventListener('search:open', this._onOpen);
      document.removeEventListener('keydown', this._onDocKey);
    }

    bind() {
      var self = this;
      this._onOpen = function (e) {
        e.preventDefault();
        self.open();
      };
      document.addEventListener('search:open', this._onOpen);

      // “/” 快捷键（焦点不在可输入元素上时）
      this._onDocKey = function (e) {
        if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
        var t = e.target;
        if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable)) return;
        if (document.querySelector('dialog[open]')) return;
        e.preventDefault();
        self.open();
      };
      document.addEventListener('keydown', this._onDocKey);

      this.querySelectorAll('[data-search-close]').forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });
      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', function () {
          self.input.value = '';
          self.input.focus();
          self.reset();
        });
      }
      // Esc：先动画再 close
      this.dialog.addEventListener('cancel', function (e) {
        e.preventDefault();
        self.close();
      });
      // 点浮层外（::backdrop）关闭
      this.dialog.addEventListener('click', function (e) {
        if (e.target === self.dialog) self.close();
      });

      this.input.addEventListener('input', function () { self.onInput(); });
      this.input.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          var first = self.results.querySelector('a');
          if (first) { e.preventDefault(); first.focus(); }
        }
      });
      this.results.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        var links = Array.prototype.slice.call(self.results.querySelectorAll('a'));
        var i = links.indexOf(document.activeElement);
        if (i === -1) return;
        e.preventDefault();
        if (e.key === 'ArrowDown') {
          if (links[i + 1]) links[i + 1].focus();
        } else if (i === 0) {
          self.input.focus();
        } else {
          links[i - 1].focus();
        }
      });
      // 请求失败后的「Try again」（委托在结果容器上，innerHTML 被换掉也不会丢）
      this.results.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('[data-search-retry]') : null;
        if (!btn) return;
        e.preventDefault();
        var q = self.input.value.trim();
        if (q.length < MIN_CHARS) { self.reset(); self.input.focus(); return; }
        delete self.cache[q];
        self.lastQuery = '';
        self.fetchResults(q);
      });

      // 空查询不提交
      this.form.addEventListener('submit', function (e) {
        if (!self.input.value.trim()) e.preventDefault();
      });
    }

    open() {
      var d = this.dialog;
      var self = this;
      if (d.open) { this.input.focus(); return; }
      try {
        if (typeof d.showModal === 'function') d.showModal();
        else d.setAttribute('open', '');
      } catch (err) {
        d.setAttribute('open', '');
      }
      var show = function () { d.classList.add('is-open'); };
      requestAnimationFrame(function () { requestAnimationFrame(show); });
      setTimeout(show, 80);
      setTimeout(function () { self.input.focus({ preventScroll: true }); }, 30);
      this.input.setAttribute('aria-expanded', 'true');
    }

    close() {
      var d = this.dialog;
      if (!d.open) return;
      d.classList.remove('is-open');
      this.input.setAttribute('aria-expanded', 'false');
      var done = function () {
        if (typeof d.close === 'function') d.close();
        else d.removeAttribute('open');
      };
      if (MQ_REDUCED.matches) done();
      else setTimeout(done, CLOSE_MS);
    }

    onInput() {
      var self = this;
      var q = this.input.value.trim();
      if (this.clearBtn) this.clearBtn.hidden = q.length === 0;
      clearTimeout(this.timer);
      if (q.length < MIN_CHARS) {
        this.reset();
        return;
      }
      this.timer = setTimeout(function () { self.fetchResults(q); }, DEBOUNCE_MS);
    }

    reset() {
      if (this.abort) { this.abort.abort(); this.abort = null; }
      clearTimeout(this.loadTimer);
      this.lastQuery = '';
      this.pending = '';
      this.results.setAttribute('aria-busy', 'false');
      this.results.innerHTML = this.quickHTML;
      this.announce('');
    }

    fetchResults(q) {
      var self = this;
      // 审计 #10：原来在发请求之前就把 q 写进 lastQuery，请求一失败就再也不会重发同一个词，
      // 面板还留着上一个词的结果。改成只有成功渲染后才认这个词，失败时 lastQuery 保持空。
      if (q === this.lastQuery) {
        /* 面板已经在显示这个词的结果了，不用重发。但**必须**先把状态归位：
           在途的别的词（用户打快了又删回来）如果不掐掉，它回来时 pending 仍等于它自己，
           就会把面板刷成那个词的结果 —— 输入框写着 mirror、面板却是 floor lamp。
           2026-09-08 线上实测复现过，是修 #10 时新引进的回归，不是原有问题。 */
        if (this.pending !== q) {
          if (this.abort) { this.abort.abort(); this.abort = null; }
          this.pending = q;
          clearTimeout(this.loadTimer);
          this.results.setAttribute('aria-busy', 'false');
        }
        return;
      }
      this.pending = q;
      if (this.cache[q]) { this.lastQuery = q; this.render(this.cache[q], q); return; }
      if (this.abort) this.abort.abort();
      this.abort = new AbortController();
      var limit = parseInt(this.dataset.limit, 10) || 6;
      var url = (this.dataset.url || '/search/suggest')
        + '?q=' + encodeURIComponent(q)
        + '&resources[type]=product,query,collection,page,article'
        + '&resources[limit]=' + limit
        + '&resources[limit_scope]=each'
        + '&resources[options][unavailable_products]=last'
        + '&resources[options][fields]=title,product_type,variants.title,vendor'
        + '&section_id=' + encodeURIComponent(this.dataset.section || 'xp-predictive-search');
      this.showLoading(q);
      fetch(url, { signal: this.abort.signal })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var frag = doc.querySelector('#XpPredictiveResults');
          var out = frag ? frag.outerHTML : '';
          self.cache[q] = out;
          if (self.pending !== q) return;
          self.lastQuery = q;
          self.render(out, q);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (self.pending !== q) return;
          self.lastQuery = '';       // 同一个词可以原样再试一次
          self.renderError(q);
        });
    }

    // 慢请求才显示加载态（400ms 内返回的不闪），顺带把上一个词的结果清掉，
    // 免得客户看着 A 的结果以为是 B 的（审计 #10）
    showLoading(q) {
      var self = this;
      clearTimeout(this.loadTimer);
      this.results.setAttribute('aria-busy', 'true');
      this.loadTimer = setTimeout(function () {
        if (self.pending !== q) return;
        self.results.textContent = '';
        var p = document.createElement('p');
        p.className = 'xp-search__loading';
        p.textContent = self.dataset.loadingText || 'Searching…';
        self.results.appendChild(p);
      }, 400);
    }

    // 请求失败：清掉旧结果，给一条可点的重试 + 一个整站搜索兜底
    renderError(q) {
      clearTimeout(this.loadTimer);
      this.results.setAttribute('aria-busy', 'false');
      this.results.textContent = '';

      var box = document.createElement('div');
      box.className = 'xp-search__error';
      box.setAttribute('role', 'alert');

      var msg = document.createElement('p');
      msg.className = 'xp-search__error-text';
      msg.textContent = this.dataset.errorText || "We couldn't load suggestions right now.";
      box.appendChild(msg);

      var actions = document.createElement('p');
      actions.className = 'xp-search__error-actions';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'xp-search__retry';
      btn.setAttribute('data-search-retry', '');
      btn.textContent = this.dataset.retryText || 'Try again';
      actions.appendChild(btn);

      if (q) {
        var all = document.createElement('a');
        all.className = 'xp-search__error-all';
        all.href = (this.dataset.searchUrl || '/search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
        all.textContent = this.dataset.searchAllText || 'Search all products';
        actions.appendChild(all);
      }

      box.appendChild(actions);
      this.results.appendChild(box);
      this.announce(msg.textContent);
    }

    render(html, q) {
      clearTimeout(this.loadTimer);
      this.results.setAttribute('aria-busy', 'false');
      this.results.innerHTML = html;
      var frag = this.results.querySelector('#XpPredictiveResults');
      var n = frag ? parseInt(frag.dataset.count, 10) || 0 : 0;
      this.announce(n + ' ' + (this.dataset.statusLabel || 'suggestions') + ' — ' + q);
    }

    announce(text) {
      if (this.status) this.status.textContent = text;
    }
  }

  customElements.define('xp-predictive-search', XpPredictiveSearch);
})();
